export default {
  moreInfoLink: {
    id: 'product_page_telco_popup_more_info_link',
    defaultMessage: 'See offer details',
  },
}
